// extracted by mini-css-extract-plugin
module.exports = {"carousel":"category-carousel_carousel__ZgYWR","carousel__card":"category-carousel_carousel__card__mwWSj","loading":"category-carousel_loading__WWmt_"};